import { useSearchParams } from "react-router-dom";

import EmailVerification from "@/features/applications/email-verification";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return <EmailVerification token={token} />;
};

export default VerifyEmailPage;
